import React from 'react';
import './CustomDescriptionText.scss';

interface CustomDescriptionTextProps {
  description: string;
}

const CustomDescriptionText = ({ description }: CustomDescriptionTextProps) => {
  return <span className={`custom-description-text`}>{description}</span>;
};

export default CustomDescriptionText;
